import moment from 'moment';

/**
 * Capitalize every word. Skips single letters e.g `"... i ..."`.
 * @param {Date} str - The string to convert. 
 */
export const formatDateDayNameAndDate = date => {

	const today = new Date().toISOString().substr(0, 10);
	const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().substr(0, 10);

	if(date == today){
		return 'i dag';
	}
	if(date == tomorrow){
		return 'i morgen';
	}

	return moment(date).format('dddd, Do MMMM');
}

export default {
	formatDateDayNameAndDate
};
